// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TwoFactorDisable__wrapper___w+JEL","link":"TwoFactorDisable__link___A2szl","isSubmitting":"TwoFactorDisable__isSubmitting___i5bjO"};